export var CurrencyFlagSizes = /*#__PURE__*/ function(CurrencyFlagSizes) {
    CurrencyFlagSizes["SMALL"] = "sm";
    CurrencyFlagSizes["MEDIUM"] = "md";
    CurrencyFlagSizes["LARGE"] = "lg";
    CurrencyFlagSizes["XLARGE"] = "xl";
    return CurrencyFlagSizes;
}({});
